import { css } from "styled-components";

const buttonStyles = css`
  display: flex;
  align-items: center;
  font-family: var(--font-family-body);
  border-radius: var(--border-radius-medium);

  .anticon-loading {
    svg path {
      fill: var(--icon-light) !important;
      stroke: var(--icon-light) !important;
    }
  }
`;

export default buttonStyles;
